import { render, staticRenderFns } from "./explainDialog.vue?vue&type=template&id=0250d8ff"
import script from "./explainDialog.vue?vue&type=script&lang=js"
export * from "./explainDialog.vue?vue&type=script&lang=js"
import style0 from "./explainDialog.vue?vue&type=style&index=0&id=0250d8ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports